import React from "react";
import {Page, Text, View, Document, StyleSheet, Font} from "@react-pdf/renderer";
import OpenSansRegular from "../../../../../statics/typos/openSansRegular.ttf";
import OpenSansSemiBold from "../../../../../statics/typos/openSansSemiBold.ttf";
import OpenSansBold from "../../../../../statics/typos/openSansBold.ttf";
import {TrailerOrContainerOrderFileModel} from "../../../../models/order";
import {OrderFilesUtils} from "../../../../../helpers/orderFilesUtils";
import {DateUtils} from "../../../../../helpers/dateUtils";

Font.register({
    family: "OpenSans",
    format: "truetype",
    src: OpenSansRegular
});
Font.register({
    family: "OpenSansSemiBold",
    format: "truetype",
    src: OpenSansSemiBold
});
Font.register({
    family: "OpenSansBold",
    format: "truetype",
    src: OpenSansBold
});

const styles = StyleSheet.create(OrderFilesUtils.styles);

interface NoSeaTrafficOrderTrailerOrContainerFileProps {
    order: TrailerOrContainerOrderFileModel | null | undefined,
    username: string
}

export default function NoSeaTrafficOrderTrailerOrContainerFile(props: NoSeaTrafficOrderTrailerOrContainerFileProps): React.ReactElement {
    if (!props.order) {
        return <Document><Page/></Document>;
    }

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View>
                    {OrderFilesUtils.renderHeader("ZLECENIE ZŁOŻENIA NACZEPY LUB KONTENERA DO DEPO I ODBIORU Z DEPO \n " +
                        "ORDER TO LAY A TRAILER OR CONTAINER FOR DEPO AND COLLECTION FROM DEPO")}
                    {renderTable()}
                </View>
            </Page>
        </Document>
    );

    function renderTable() {
        const isToDepoStatus = OrderFilesUtils.isToDepoStatus(props.order!.status);

        return (
            <View style={styles.table}>
                <View style={styles.tableRow}>
                    {OrderFilesUtils.renderOrderType(props.order!.relationType)}
                    {OrderFilesUtils.renderOrderNo(props.order!.orderId)}
                    {OrderFilesUtils.renderCargoType(props.order!.cargoType)}
                    <View style={[styles.tableSmallCol]}>
                        <Text style={[styles.tableCellHeader]}>
                            Nr identyfikacyjny /{"\n"}
                            Identification no
                        </Text>
                        <Text style={styles.tableCellData}>
                            {OrderFilesUtils.renderMeansOfTransportNo({
                                trailerRegNo: props.order!.trailerRegNo,
                                containerNo: props.order!.containerNo
                            })}
                        </Text>
                    </View>
                </View>
                <View style={styles.tableRow}>
                    <View style={[styles.tableCol, {minHeight: 20}]}>
                        <Text style={[styles.tableCellHeader]}>
                            Do DEPO /{"\n"}
                            To DEPO
                        </Text>
                    </View>
                    <View style={[styles.tableCol, {minHeight: 20}]}>
                        <Text style={[styles.tableCellHeader]}>
                            Z DEPO /{"\n"}
                            From DEPO
                        </Text>
                    </View>
                </View>
                <View style={styles.tableRow}>
                    {OrderFilesUtils.renderTypeOfMeansOfTransportSection(
                        props.order!.relationType,
                        true,
                        props.order!.supplierLorryRegNo,
                        props.order!.supplierWagonRegNo
                    )}
                    {OrderFilesUtils.renderTypeOfMeansOfTransportSection(
                        props.order!.relationType,
                        false,
                        props.order!.recipientLorryRegNo,
                        props.order!.recipientWagonRegNo
                    )}
                </View>
                <View style={styles.tableRow}>
                    <View style={[styles.tableCol, {minHeight: 20}]}>
                        <Text style={[styles.tableCellHeader]}>
                            Składajacy /{"\n"}
                            Submitter
                        </Text>
                    </View>
                    <View style={[styles.tableCol, {minHeight: 20}]}>
                        <Text style={[styles.tableCellHeader]}>
                            Odbierający /{"\n"}
                            Receiver
                        </Text>
                    </View>
                </View>
                <View style={styles.tableRow}>
                    <View style={styles.tableCol}>
                        {OrderFilesUtils.renderTransportCompany(props.order!.transportCompany)}
                    </View>
                    <View style={styles.tableCol}>
                        {OrderFilesUtils.renderTransportCompany(props.order!.recipient)}
                    </View>
                </View>
                <View style={styles.tableRow}>
                    <View style={[styles.tableSmallCol]}>
                        {OrderFilesUtils.renderCargoWeight(props.order!.weight)}
                    </View>
                    <View style={[styles.tableSmallCol]}>
                        {OrderFilesUtils.renderDangerousGoods(props.order!.isDangerousGoods)}
                    </View>
                    <View style={[styles.tableSmallCol]}>
                        {OrderFilesUtils.requestedTemp(props.order!.requestedTemp1, 1)}
                    </View>
                    <View style={[styles.tableSmallCol]}>
                        {OrderFilesUtils.requestedTemp(props.order!.requestedTemp2, 2)}
                    </View>
                </View>
                <View style={styles.tableRow}>
                    {OrderFilesUtils.renderTimeOfDepositingLoad(props.order!.timeOfDepositingLoad)}
                    {OrderFilesUtils.renderFreeTimeFromFees(props.order!.freeTimeFromFees)}
                    <View style={styles.tableSmallCol}>
                        <Text style={styles.tableCellHeader}>
                            Data podjęcia/godz. /{"\n"}
                            Time to pick up
                        </Text>
                        <Text style={styles.tableCellData}>
                            {DateUtils.getFormattedDateWithTime(props.order!.timeToPickUp)}
                        </Text>
                    </View>
                    <View style={styles.tableSmallCol}>
                        {OrderFilesUtils.renderStorageTime(props.order!.storageTime)}
                    </View>
                </View>
                <View style={styles.tableRow}>
                    {OrderFilesUtils.renderPaymentMethod(props.order!.paymentMethod)}
                    {OrderFilesUtils.renderPaymentDocumentNumber(props.order!.paymentDocumentNumber)}
                </View>
                {OrderFilesUtils.renderRemarks(props.order!.remarks)}
                {OrderFilesUtils.requestedSignaturesForDepo(props.username, isToDepoStatus)}
            </View>
        );
    }
}

